(() => {

    const sidebar = document.querySelector('.nested-sidebar')
    if(sidebar) {
        const label = sidebar.querySelector('.nested-sidebar--label')
        const list = sidebar.querySelector('.nested-sidebar--list')

        if(label) {

            const currentOnLoad = list.querySelector('.nested-sidebar--item.current > a')
            if(currentOnLoad) {
                label.querySelector('span').innerText = currentOnLoad.innerText
            }

            label.addEventListener('click', () => {
                list.classList.toggle('active')
            })

            list.querySelectorAll('.nested-sidebar--item').forEach( item => {
                item.addEventListener('click', (e) => {
                    const href = e.target.getAttribute('href')
                    if(!href) {
                        list.classList.toggle('active')
                        label.querySelector('span').innerText = item.innerText
                    }
                })
            })
        }
    }
})()
